(function (angular) {
  var serviceId = "migrateService";

  angular
    .module("app")
    .factory(serviceId, ["$http", "$q", "Messages", function ($http, $q, Messages) {

      function authenticate(creds) {
        Messages.clear();

        var deferred = $q.defer();

        $http.post("/api/Migrate/Authenticate", creds).then(function (resp) {
          deferred.resolve(resp.data);
        }, function (err) {
          if (err.status === 401) {
            Messages.add("danger", "Invalid username or password", {
              showOnNextPage: false
            });
          }
          if (err.status === 400 && err.data !== "") {
            // bad request, display the message 
            Messages.add("danger", err.data, {
              showOnNextPage: false
            });

          } else {
            Messages.add("danger", "We have encountered an error and are unable to proceed. Please contact PC*MILER|Web Support team at <a href='mailto:pcmsupport@alk.com'>pcmsupport@alk.com</a> to complete the update process.", {
              showOnNextPage: false
            });
          }

          deferred.reject(err);
          return $q.reject(err);
        });

        return deferred.promise;
      }

      function migrate(data) {
        Messages.clear();

        var deferred = $q.defer();

        $http.post("/api/Migrate/Migrate", data).then(function (resp) {
          deferred.resolve(resp.data);
        }, function (err) {
          if (err.status === 400 && err.data !== "") {
            // bad request, display the message 
            Messages.add("danger", err.data, {
              showOnNextPage: false
            });

          } else {
            Messages.add("danger", "We have encountered an error and are unable to proceed. Please contact PC*MILER|Web Support team at <a href='mailto:pcmsupport@alk.com'>pcmsupport@alk.com</a> to complete the update process.", {
              showOnNextPage: false
            });
          }

          deferred.reject(err);
          return $q.reject(err);
        });

        return deferred.promise;
      }

      return {
        authenticate: authenticate,
        migrate: migrate
      };
    }]);
})(angular);



// WEBPACK FOOTER //
// ./app/account/migrate.service.js